// TODO: eventually we would need to hook up to notification or some global message bar

/// <amd-module name="Build/Common/Library/ErrorHandler" />
namespace ErrorHandlerHelper {
    export var registeredHandler: (error: Error) => any;
}

/// <amd-module name="Build/Common/Library/ErrorHandler" />
export function handleError(error: Error) {
    console.error(error);
    if (ErrorHandlerHelper.registeredHandler) {
        ErrorHandlerHelper.registeredHandler(error);
    }
}

export function registerErrorHandler(handler: (error: Error) => any) {
    ErrorHandlerHelper.registeredHandler = handler;
}
